<div class="dashboard-content-header" [ngClass]="{ 'p-l-0': isShowLCLHeader }">
  <div *ngIf="isShowBasicHeader; else lclBookingHeader" class="w-100 d-flex justify-content-between align-items-center">
    <div *ngIf="headerData" class="d-flex print-margin-auto align-items-center">
      <div>
        <span *ngFor="let segment of headerData.title; let last = last" class="d-print-none">
          <a
            *ngIf="segment.link"
            class="segment-link"
            [routerLink]="'/' + (segment.link | translate : segment.params)"
            [queryParams]="queryParams(segment)"
          >
            {{ segment.key | translate : segment.params }}
          </a>
          <span *ngIf="!segment.link && !segment.params?.intranslatable" class="segment-link">
            {{ segment.key | translate : segment.params }}
          </span>
          <span *ngIf="!segment.link && segment.params?.intranslatable" class="segment-link">
            {{ segment.key }}
          </span>
          <span class="slash" *ngIf="!last">/</span>
        </span>
        <span *ngFor="let segment of headerData.printTitle || headerData.title; let last = last" class="d-print-inline d-none">
          <span class="segment-link" *ngIf="!segment.params?.intranslatable">
            {{ segment.key | translate : segment.params }}
          </span>
          <span class="segment-link" *ngIf="segment.params?.intranslatable">
            {{ segment.key }}
          </span>
          <span class="slash" *ngIf="!last">/</span>
        </span>
      </div>
      <div class="dashboard-content-header__badge-wrapper ml-4">
        <app-header-badge></app-header-badge>
      </div>
      <div class="context-items-status ml-4">
        <app-header-status></app-header-status>
      </div>
      <div *ngIf="isShowInternalNotes" class="ml-4">
        <ng-container *ngTemplateOutlet="internalNotes"></ng-container>
      </div>
    </div>

    <div class="action-block d-print-none" fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="center center">
      <div class="wrapper-actions">
        <app-header-actions></app-header-actions>

        <div *ngIf="isShowRecalculate" class="ml-4">
          <ng-container *ngTemplateOutlet="recalculateInsurance"></ng-container>
        </div>
      </div>
      <img
        *ngIf="isHtsCatalogArea"
        class="hts-toggle-icon"
        [src]="htsToggleIcon"
        alt="hts"
        nz-tooltip
        nzTooltipPlacement="bottom"
        [nzTooltipTitle]="htsToggleTooltip | translate"
        (click)="onToggleHtsHistory()"
      />
      <ng-container *ngTemplateOutlet="navBar"></ng-container>
    </div>
  </div>
</div>

<ng-template #lclBookingHeader>
  <div class="d-flex flex-column w-100">
    <div class="d-flex w-100 border-bottom-custom">
      <app-lcl-header-detailed-info
        [template]="enumDetailedInfoPlacementEnum.headerTemplate"
        [referenceName]="headerType === headerTypes.LCLShipment ? 'LABELS.SHIPMENT' : 'LABELS.QUOTE_ID'"
        [referenceValue]="headerType === headerTypes.LCLShipment ? (shipment$ | async)?.referenceNumber : (quote$ | async)?.referenceNumber"
        [info]="headerType === headerTypes.LCLShipment ? (shipment$ | async) : (quote$ | async)"
        [isQuote]="headerType !== headerTypes.LCLShipment"
        [isShowInsuranceIcon]="headerType === headerTypes.LCLShipment"
        class="w-100"
      >
        <ng-container *ngTemplateOutlet="navBar"></ng-container>
      </app-lcl-header-detailed-info>
    </div>

    <div *ngIf="headerType === headerTypes.LCLShipment" class="d-flex w-100 lcl-additional-info">
      <app-lcl-shipment-voyage-info [shipment]="shipment$ | async"></app-lcl-shipment-voyage-info>
    </div>
  </div>
</ng-template>

<ng-template #internalNotes>
  <div class="internal-notes-container" (click)="openInternalNotes()">
    <img
      [src]="
        !!internalNote.internalReferenceNumber || !!internalNote.internalNotes
          ? 'assets/icons/icon_edit_notes.svg'
          : 'assets/icons/icon_add_notes.svg'
      "
    />
    <span
      nz-tooltip
      nzTooltipColor="#ffffff"
      nzTooltipOverlayClassName="tooltip-sm"
      nzTooltipPlacement="bottom"
      [nzTooltipTitle]="
        (!!internalNote.internalReferenceNumber || !!internalNote.internalNotes
          ? 'LABELS.INTERNAL_NOTES_EDIT_HINT'
          : 'LABELS.INTERNAL_NOTES_ADD_HINT'
        ) | translate
      "
    >
      {{
        (!!internalNote.internalReferenceNumber || !!internalNote.internalNotes
          ? "LABELS.INTERNAL_NOTES_EDIT_BUTTON"
          : "LABELS.INTERNAL_NOTES_ADD_BUTTON"
        ) | translate
      }}
    </span>
  </div>
</ng-template>

<ng-template #recalculateInsurance>
  <button type="button" class="header-button-insurance" (click)="openRecalculate()">
    <img alt="recalculate" src="/assets/icons/icon_calculator_white.svg" />
    {{ "RECALCULATE_BEFORE_EDIT" | translate }}
  </button>
</ng-template>

<ng-template #navBar>
  <div
    class="header-menu-profile-wrapper"
    dropdown
    placement="bottom right"
    container="body"
    insideClick="true"
    #dropdown="bs-dropdown"
    (isOpenChange)="onDropdownOpenChange($event)"
  >
    <div class="header-menu-profile" [ngClass]="{ 'is-opened': false }" dropdownToggle>
      <div
        class="header-menu-profile-avatar"
        [ngStyle]="{ 'background-image': 'url(' + company?.logoUri + ')' }"
        *ngIf="!!company?.logoUri"
      ></div>
      <div class="header-menu-profile-name">{{ !!company?.businessName ? company?.businessName : smallName }}</div>
      <div class="header-menu-profile-icon"><img alt="menu" src="/assets/icons/icon_chevron_xl.svg" /></div>
    </div>

    <div class="dropdown-menu dropdown-menu-right dropdown-menu-company" *dropdownMenu>
      <div class="dropdown-menu-company-header">
        <div
          class="dropdown-menu-company-header-avatar"
          [ngStyle]="{ 'background-image': 'url(' + company?.logoUri + ')' }"
          *ngIf="!!company?.logoUri"
        ></div>
        <div class="dropdown-menu-company-header-name">
          <div *ngIf="!!company?.businessName">
            <h3 class="cursor-pointer" (click)="dropdown.hide(); redirectToCompanyView(company)">{{ company?.businessName }}</h3>
            <p>{{ user?.firstName + " " + user?.lastName }}</p>
          </div>

          <div *ngIf="!company?.businessName">
            <h3>{{ user?.firstName + " " + user?.lastName }}</h3>
          </div>
        </div>
      </div>

      <div class="dropdown-menu-company-menu">
        <section *ngIf="isAllowSwitchMode">
          <a (click)="dropdown.hide(); switchActiveApplicationMode()">
            {{ "MENU.SWITCH_TO_ROLE_" + (isActiveSupportMode ? "USER" : "SUPPORT") | translate }}
          </a>
          <div class="line"></div>
        </section>

        <section *ngIf="hasMultipleOrganizations && isActiveUserMode">
          <a (click)="dropdown.hide(); switchOrganization()">
            {{ "MENU.SWITCH_ORGANIZATION" | translate }}
          </a>
          <div class="line"></div>
        </section>

        <input
          *ngIf="isShowCompanySearch"
          type="text"
          class="form-control company-search-input"
          [placeholder]="'FORM_LABEL.SEARCH_IMPORTERS_OF_RECORD' | translate"
          name="company-search"
          (input)="onCompanySearchInput($event)"
        />

        <section class="dropdown-menu-company-menu-companies" *ngIf="companies?.length && isActiveUserMode">
          <a
            class="dropdown-menu-company-menu-companies-item"
            [ngClass]="{ 'is-selected': isCurrentCompany(company_a.id) }"
            *ngFor="let company_a of filteredCompanies; let i = index"
            [title]="getCompanyLabel(company_a, i)"
            (click)="dropdown.hide(); resetCompanySearch(); selectCompany($event, company_a)"
          >
            <span>
              <span class="company-name-text">{{ getCompanyLabel(company_a, i) }}</span>

              <img alt="company is selected" src="/assets/icons/icon_check_green.svg" />
            </span>

            <span class="dropdown-menu-company-menu-companies-item-hint" *ngIf="!company_a?.businessName">
              {{ "COMPLETE_IOR_PROFILE" | translate }}
            </span>
          </a>
        </section>

        <section>
          <div class="line" *ngIf="isActiveUserMode"></div>

          <a [routerLink]="['/companies', 'account-settings']" (click)="dropdown.hide()">
            {{ "MENU.ACCOUNT_SETTINGS" | translate }}
          </a>

          <ng-container *ngIf="isActiveUserMode">
            <a *ngIf="isShowSelfFiller" [routerLink]="['/companies', 'self-filer']" (click)="dropdown.hide()">
              {{ "MENU.SELF_FILER" | translate }}
            </a>
          </ng-container>

          <div class="line"></div>
        </section>

        <section>
          <a *ngIf="isActiveUserMode" [routerLink]="['/legal-terms']" (click)="dropdown.hide()">
            {{ "MENU.LEGAL_TERMS" | translate }}
          </a>
          <a *ngIf="isActiveUserMode" [routerLink]="['/privacy-policy']" (click)="dropdown.hide()">
            {{ "PAGE.POLICY.PRIVACY_POLICY" | translate }}
          </a>
          <a [routerLink]="['/login']" (click)="dropdown.hide(); logout($event)">
            {{ "MENU.LOG_OUT" | translate }}
          </a>
        </section>
      </div>
    </div>
  </div>
</ng-template>
